import React, { useState, useEffect } from 'react';
import { Table, Button, Space, message, Card, Input, Select, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, SyncOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { marketingAPI } from '../../services/marketingAPI';
import { getInfluencerColumns } from './components/InfluencerTableConfig';

const { Option } = Select;

const InfluencerLibrary: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [influencers, setInfluencers] = useState<any[]>([]);
    const [filters, setFilters] = useState<any>({});
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 50, total: 0 });

    const fetchInfluencers = async (page = 1, pageSize = 50) => {
        setLoading(true);
        try {
            const params = { ...filters, page, page_size: pageSize };
            const { data } = await marketingAPI.listInfluencers(params);

            if (Array.isArray(data)) {
                setInfluencers(data);
                setPagination({ ...pagination, current: page, pageSize, total: data.length });
            } else {
                const res = data as any;
                setInfluencers(res.results || []);
                setPagination({
                    current: page,
                    pageSize,
                    total: res.count || 0
                });
            }
        } catch (error) {
            message.error('加载红人列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInfluencers(1, pagination.pageSize);
    }, [filters]);

    const handleTableChange = (newPagination: any) => {
        fetchInfluencers(newPagination.current, newPagination.pageSize);
    };

    const handleSearch = (value: string) => {
        setFilters({ ...filters, search: value });
    };

    const handleDelete = async (id: number) => {
        try {
            await marketingAPI.deleteInfluencer(id);
            message.success('删除成功');
            fetchInfluencers(pagination.current, pagination.pageSize);
        } catch (error) {
            message.error('删除失败');
        }
    };

    const columns = getInfluencerColumns(navigate, handleDelete);

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <Space>
                    <Input.Search
                        placeholder="搜索名称、标签..."
                        onSearch={handleSearch}
                        style={{ width: 200 }}
                    />
                    <Select placeholder="状态筛选" style={{ width: 120 }} allowClear onChange={(val) => setFilters({ ...filters, status: val })}>
                        <Option value="new">New</Option>
                        <Option value="contacted">Contacted</Option>
                        <Option value="cooperating">Cooperating</Option>
                    </Select>
                </Space>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/marketing/influencers/new')}>
                    添加红人
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={Array.isArray(influencers) ? influencers : []}
                rowKey="id"
                loading={loading}
                rowSelection={{
                    selectedRowKeys,
                    onChange: (keys) => setSelectedRowKeys(keys),
                }}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showTotal: (total) => `共 ${total} 条数据`,
                }}
                onChange={handleTableChange}
                scroll={{ x: 1500 }}
            />
        </div>
    );
};

export default InfluencerLibrary;
